import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';

const SECTION_VARIANT = {
    Added: 'text-success',
    Fixed: 'text-warning',
    Changed: 'text-info',
    Performance: 'text-primary',
    Migration: 'text-secondary',
};

function parseChangelog(text) {
    const releases = [];
    const versionBlocks = text.split(/^## /m).slice(1);

    for (const block of versionBlocks) {
        const lines = block.split('\n');
        const header = lines[0];
        const match = header.match(/\[(.+?)\]\s*-\s*(.+)/);
        if (!match) continue;

        const [, version, date] = match;
        const sections = {};
        let currentSection = null;

        for (const line of lines.slice(1)) {
            const sectionMatch = line.match(/^### (.+)/);
            if (sectionMatch) {
                currentSection = sectionMatch[1].trim();
                sections[currentSection] = [];
            } else if (currentSection && line.startsWith('- ')) {
                sections[currentSection].push(line.slice(2).trim());
            }
        }

        releases.push({ version, date: date.trim(), sections });
    }

    return releases;
}

const VersionBadge = ({ mobile }) => {
    const [show, setShow] = useState(false);
    const [changelog, setChangelog] = useState([]);
    const [version, setVersion] = useState('');

    useEffect(() => {
        fetch('/CHANGELOG.md')
            .then(r => r.text())
            .then(text => {
                const releases = parseChangelog(text);
                setChangelog(releases);
                if (releases.length > 0) setVersion(releases[0].version);
            })
            .catch(() => {});
    }, []);

    if (!version) return null;

    const modal = (
        <Modal show={show} onHide={() => setShow(false)} scrollable>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: '1rem' }}>Changelog</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ fontSize: '0.875rem' }}>
                {changelog.map(({ version: v, date, sections }) => (
                    <div key={v} className="mb-4">
                        <div className="d-flex align-items-baseline gap-2 mb-2">
                            <strong>v{v}</strong>
                            <small className="text-muted">{date}</small>
                        </div>
                        {Object.entries(sections).map(([heading, items]) => (
                            <div key={heading} className="mb-2">
                                <span className={`fw-semibold ${SECTION_VARIANT[heading] ?? ''}`}>
                                    {heading}
                                </span>
                                <ul className="mb-0 mt-1" style={{ paddingLeft: '1.25rem' }}>
                                    {items.map((item, i) => <li key={i}>{item}</li>)}
                                </ul>
                            </div>
                        ))}
                    </div>
                ))}
            </Modal.Body>
        </Modal>
    );

    if (mobile) {
        return (
            <>
                <span
                    onClick={() => setShow(true)}
                    className="mobile-version-badge"
                    style={{
                        cursor: 'pointer',
                        color: 'var(--secondary-color)',
                        fontSize: '0.75rem',
                        opacity: 0.7,
                    }}
                >
                    v{version}
                </span>
                {modal}
            </>
        );
    }

    return (
        <>
            <button
                onClick={() => setShow(true)}
                className="version-badge-fixed"
                style={{
                    position: 'fixed',
                    bottom: '12px',
                    left: '12px',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    color: 'var(--secondary-color)',
                    fontSize: '0.7rem',
                    opacity: 0.6,
                    zIndex: 1000,
                }}
            >
                v{version}
            </button>
            {modal}
        </>
    );
};

export default VersionBadge;
